exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._EventHandleCommon_ .ant-card:nth-child(2),\n._EventHandleCommon_ .ant-card:nth-child(3) {\n  margin-top: 16px;\n}\n._EventHandleCommon_ .ant-col {\n  height: 30px;\n  line-height: 30px;\n}\n._EventHandleCommon_ .formItem {\n  margin-bottom: 14px;\n}\n._EventHandleCommon_ .formItem .input {\n  width: 100%;\n  margin-right: 10px;\n}\n._EventHandleCommon_ .firstFormItem {\n  padding-left: 18px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n", ""]);

// exports
